// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wttZtIMVK8vXoDULVxXg{flex-direction:column;flex:1;justify-content:center;width:100%;max-width:628px;margin:0 auto;display:flex}.wttZtIMVK8vXoDULVxXg .TP5SC3lKavstWUJrgZsU{flex-direction:row;justify-content:center;gap:8px;display:flex}.wttZtIMVK8vXoDULVxXg .yyAqGkRSiisUtArBv3tE{text-align:center;flex-direction:column;display:flex}.wttZtIMVK8vXoDULVxXg .dhLvXg_k5d4G9ydQ8Stq{border-radius:16px;align-items:flex-end;margin-bottom:40px;display:flex;overflow:hidden}.wttZtIMVK8vXoDULVxXg .dhLvXg_k5d4G9ydQ8Stq img{width:100%;height:auto;display:block}.uO7QonZL68acRtwcRsRF{width:109px;text-decoration:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"empty": `wttZtIMVK8vXoDULVxXg`,
	"actions": `TP5SC3lKavstWUJrgZsU`,
	"title": `yyAqGkRSiisUtArBv3tE`,
	"titlePreview": `dhLvXg_k5d4G9ydQ8Stq`,
	"guideButton": `uO7QonZL68acRtwcRsRF`
};
export default ___CSS_LOADER_EXPORT___;
